import { Link } from 'react-router-dom';
import { Linkedin, Youtube, Instagram, Mail, Phone, MapPin } from 'lucide-react';
import { BRAND } from '@/data/mockData';
import { NAV } from '@/constants/testIds';

const Footer = () => {
  return (
    <footer className="relative mt-32 border-t border-white/5 bg-[#050A14]">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-brand-cyan/50 to-transparent" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="flex items-center gap-3">
            <img src={BRAND.logoUrl} alt="BYMAT" className="h-12 w-12 object-contain rounded-lg bg-black" />
            <div>
              <div className="font-display text-xl font-black">BYMAT</div>
              <div className="text-[10px] tracking-[0.3em] text-brand-cyan/80 font-mono uppercase -mt-0.5">Automation</div>
            </div>
          </div>
          <p className="mt-5 text-sm text-brand-ink leading-relaxed max-w-xs">
            India&rsquo;s premium GenAI Automation Testing mentorship platform. Transforming 1 million IT careers.
          </p>
          <div className="mt-6 flex items-center gap-3">
            <a href={BRAND.social.linkedin} target="_blank" rel="noreferrer" data-testid={NAV.footerSocialLinkedin}
              className="h-10 w-10 rounded-lg glass flex items-center justify-center hover:bg-brand-cyan/10 hover:text-brand-cyan transition">
              <Linkedin className="w-4 h-4" />
            </a>
            <a href={BRAND.social.youtube} target="_blank" rel="noreferrer" data-testid={NAV.footerSocialYoutube}
              className="h-10 w-10 rounded-lg glass flex items-center justify-center hover:bg-brand-cyan/10 hover:text-brand-cyan transition">
              <Youtube className="w-4 h-4" />
            </a>
            <a href={BRAND.social.instagram} target="_blank" rel="noreferrer" data-testid={NAV.footerSocialInstagram}
              className="h-10 w-10 rounded-lg glass flex items-center justify-center hover:bg-brand-cyan/10 hover:text-brand-cyan transition">
              <Instagram className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="md:col-span-2">
          <div className="text-xs tracking-[0.25em] uppercase text-brand-cyan/80 font-mono mb-4">Explore</div>
          <ul className="space-y-2.5 text-sm text-white/70">
            <li><Link to="/" className="hover:text-brand-cyan transition">Home</Link></li>
            <li><Link to="/programs" className="hover:text-brand-cyan transition">Programs</Link></li>
            <li><Link to="/success-stories" className="hover:text-brand-cyan transition">Success Stories</Link></li>
            <li><Link to="/about" className="hover:text-brand-cyan transition">About</Link></li>
            <li><Link to="/gallery" className="hover:text-brand-cyan transition">Gallery</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs tracking-[0.25em] uppercase text-brand-cyan/80 font-mono mb-4">Programs</div>
          <ul className="space-y-2.5 text-sm text-white/70">
            <li><Link to="/programs#selenium" className="hover:text-brand-cyan transition">Selenium + Java + AI</Link></li>
            <li><Link to="/programs#playwright" className="hover:text-brand-cyan transition">Playwright + JS + AI</Link></li>
            <li><Link to="/programs#appium" className="hover:text-brand-cyan transition">Appium + Java + AI</Link></li>
            <li><Link to="/learning-hub" className="hover:text-brand-cyan transition">Learning Hub Login</Link></li>
            <li><Link to="/feedback" className="hover:text-brand-cyan transition">Feedback & Certificate</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs tracking-[0.25em] uppercase text-brand-cyan/80 font-mono mb-4">Contact</div>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-start gap-3"><Phone className="w-4 h-4 mt-0.5 text-brand-cyan" /> {BRAND.phone}</li>
            <li className="flex items-start gap-3"><Mail className="w-4 h-4 mt-0.5 text-brand-cyan" /> {BRAND.email}</li>
            <li className="flex items-start gap-3"><MapPin className="w-4 h-4 mt-0.5 text-brand-cyan" /> {BRAND.address}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col md:flex-row gap-3 items-center justify-between text-xs text-white/50">
          <div>© {new Date().getFullYear()} BYMAT Automation. All rights reserved.</div>
          <div className="flex items-center gap-5">
            <a href="#" className="hover:text-brand-cyan">Privacy Policy</a>
            <a href="#" className="hover:text-brand-cyan">Terms & Conditions</a>
            <a href="#" className="hover:text-brand-cyan">Refund Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
